import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import NavbarWrapper from './navbarWrapper'

// import Footer from './footer'

const Layout = ({ children }) => (
  <>
    <Helmet
      title="Supernova"
      meta={[
        {
          name: 'description',
          content:
            'Supernova is an annual, all-day long festival that celebrates the journey of innovators, from ideation to development and up until market launch and growth. Supernova creates a platform for startups across different stages of their paths to connect with mentors, local and international investors, potential partners, and media personnel.',
        },
        { name: 'keywords', content: 'sample, something' },
      ]}
    >
      <html lang="en" />
    </Helmet>
    <NavbarWrapper />
    <div>{children}</div>
    {/* <Footer /> */}
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
